<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Notfallplan</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" (keyup.enter)="SavePlan()">
  @if(Plan != null)
  {
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <textarea class="form-control" id="NotfallplanSonst" [(ngModel)]="Plan.erkrankung"></textarea>
        <label for="NotfallplanSonst">Erkrankung</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <textarea class="form-control" id="NotfallplanSonst" [(ngModel)]="Plan.medikamente"></textarea>
        <label for="NotfallplanSonst">Medikamente</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating  mb-3">
        <select class="form-select"
                id="pflegegradInfo"
                [(ngModel)]="Plan.pflegegradInfo">

          <option *ngFor="let item of pflegegradInfoEnum" [ngValue]="item.id">
            {{ item.name }}
          </option>
        </select>

        <label for="pflegegradInfo">Pflegegrad vorhanden</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <textarea class="form-control" id="NotfallplanSonst" [(ngModel)]="Plan.notfallplanSonst"></textarea>
        <label for="NotfallplanSonst">Notfallplan Infos</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-check mb-3">
        <input name="Notrufe" id="Notrufe" class="form-check-input" type="checkbox"
               [checked]="Plan.notrufe"
               (change)="Plan.notrufe = !Plan.notrufe " />
        <label for="Notrufe" class="form-check-label">Notrufe</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-check mb-3">
        <input name="TechnischeMeldungen" id="TechnischeMeldungen" class="form-check-input" type="checkbox"
               [checked]="Plan.technischeMeldungen"
               (change)="Plan.technischeMeldungen = !Plan.technischeMeldungen " />
        <label for="TechnischeMeldungen" class="form-check-label">Technische Meldungen</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Wohnanlage" [(ngModel)]="Plan.wohnanlage">
        <label for="Wohnanlage">Wohnanlage</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">

      <div class="form-check mb-3">
        <input name="IsMehrPateien" id="IsMehrPateien" class="form-check-input" type="checkbox"
               [checked]="Plan.isMehrPateien"
               (change)="Plan.isMehrPateien = !Plan.isMehrPateien " />
        <label for="IsMehrPateien" class="form-check-label">Is Mehrparteienhaus</label>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="Etage" [(ngModel)]="Plan.etage">
        <label for="Etage">Etage</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Wohnungsnumme" [(ngModel)]="Plan.wohnungsnumme">
        <label for="Wohnungsnumme">Wohnungsnumme</label>
      </div>
    </div>
  </div>

  <div class="card AuftragsCard">
    <h3>Hausarzt</h3>
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="ArtztName" [(ngModel)]="Plan.hausarzt.name">
            <label for="ArtztName">Name</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="ArztPhone" Phonenumber [(ngModel)]="Plan.hausarzt.telefon">
            <label for="ArztPhone">Telefon</label>
          </div>
        </div>
      </div>
      <Address [(address)]="Plan.hausarzt.addresse"></Address>
    </div>
  </div>

  <div class="card AuftragsCard">
    <h3>Notdienst</h3>
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="notdienstName" [(ngModel)]="Plan.notdienst.name">
            <label for="notdienstName">Name</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="notdienstPhone" Phonenumber [(ngModel)]="Plan.notdienst.telefon">
            <label for="notdienstPhone">Telefon</label>
          </div>
        </div>
      </div>
      <Address [(address)]="Plan.notdienst.addresse"></Address>
    </div>
  </div>

  <div class="card AuftragsCard">
    <h3>Rettungsdienst</h3>
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="rettungsdienstName" [(ngModel)]="Plan.rettungsdienst.name">
            <label for="rettungsdienstName">Name</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="rettungsdienstPhone"  Phonenumber [(ngModel)]="Plan.rettungsdienst.telefon">
            <label for="rettungsdienstPhone">Telefon</label>
          </div>
        </div>
      </div>
      <Address [(address)]="Plan.rettungsdienst.addresse"></Address>
    </div>
  </div>

  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('')">Abbrechen</button>
  <button type="button" class="btn btn-success" (click)="SavePlan()" *IsSpezialUser>Speichern</button>
</div>
<ng-template #successTpl>  Speichern erfolgreich! </ng-template>
